import React, { useEffect, useState } from "react";
import userActions from "../../users/actions";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../common/components/Loader";
import ConfirmationModal from "../../common/components/ConfirmationModal";
import Portal from "../../common/components/Portal";
import Draggable from "react-draggable";
import AppLoaderOverlay from "../../common/components/AppLoaderOverlay";
import { useDefaultProjectUpdate } from "./useDefaultProjectUpdate";
export const DefaultProjectModal = props => {
    const dispatch = useDispatch();
    const { getUserByIdResponse } = useSelector(state => state.userReducer);
    const [isLoading, setLoading] = useState(true);
    const [defaultProject, setDefaultProject] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [showRedirectConfirmation, setShowRedirectConfirmation] = useState(false);
    const userId = localStorage.getItem("userId");

    const cancel = async () => {
        setErrorMessage("");
        props.onCancel();
    };

    const {
        projects,
        isSubmitting,
        isSwitching,
        applyProjectClients,
        updateDefaultProject,
        resolveRedirectsToAssetDashboard,
        isOnTargetDashboard
    } = useDefaultProjectUpdate({ onUpdated: cancel });
    const redirectsToAssetDashboard = resolveRedirectsToAssetDashboard();

    useEffect(() => {
        dispatch(userActions.getAllProjectsDropdown());
        dispatch(userActions.getUserById(userId));
    }, []);

    useEffect(() => {
        if (getUserByIdResponse?.success) {
            setDefaultProject(getUserByIdResponse?.default_project?.id);
            setLoading(false);
        }
    }, [getUserByIdResponse]);

    const validate = () => {
        setErrorMessage("");
        if (!defaultProject?.trim()?.length) {
            setErrorMessage("* Default project required");
            return false;
        }

        return true;
    };

    const handleSubmit = () => {
        if (validate()) {
            isOnTargetDashboard() ? updateDefaultProject(defaultProject) : setShowRedirectConfirmation(true);
        }
    };

    const renderRedirectConfirmation = () => {
        if (!showRedirectConfirmation) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={`Changing the default project will redirect you to the ${
                            redirectsToAssetDashboard ? "Asset Dashboard" : "FCA Dashboard"
                        }`}
                        message={"Are you sure that you need to update default project?"}
                        onNo={() => setShowRedirectConfirmation(false)}
                        onYes={() => {
                            setShowRedirectConfirmation(false);
                            updateDefaultProject(defaultProject);
                        }}
                    />
                }
                onCancel={() => setShowRedirectConfirmation(false)}
            />
        );
    };
    return (
        <React.Fragment>
            {isSwitching && <AppLoaderOverlay message="Switching project..." />}
            {renderRedirectConfirmation()}
            {isLoading ? (
                <Loader />
            ) : (
                <div
                    className="modal modal-region rst-pwd"
                    style={{ display: "block" }}
                    id="modalId"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                >
                    <Draggable handle=".draggable" cancel=".not-draggable">
                        <div className="modal-dialog " role="document">
                            <div className="modal-content">
                                <div className="modal-header draggable">
                                    <h5 className="modal-title" id="exampleModalLabel">
                                        Default Project
                                    </h5>
                                    <button
                                        type="button"
                                        className="close not-draggable"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                        onClick={() => props.onCancel()}
                                    >
                                        <span aria-hidden="true">
                                            <img src="/img/close.svg" alt="" />
                                        </span>
                                    </button>
                                </div>
                                <div className="modal-body region-otr build-type-mod">
                                    <form autoComplete="nope">
                                        <div className="clr-list ">
                                            <div className="col-md-12 mb-4 p-0 ">
                                                <div className="codeOtr">
                                                    <h4>Default Project</h4>
                                                    <div className="custom-selecbox">
                                                        <select
                                                            autoComplete="nope"
                                                            className={`custom-selecbox form-control ${errorMessage ? "error-border" : ""}`}
                                                            onChange={async e => {
                                                                const selectedProjectId = e.target.value;
                                                                setDefaultProject(selectedProjectId);
                                                                applyProjectClients(selectedProjectId);
                                                            }}
                                                            value={defaultProject}
                                                        >
                                                            <option value="">Select</option>
                                                            {projects?.length
                                                                ? projects.map((item, i) => (
                                                                      <option value={item.id} key={i}>
                                                                          {item.name}
                                                                      </option>
                                                                  ))
                                                                : null}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="text-danger mb-2">{errorMessage}</div>
                                        </div>
                                    </form>
                                    <div className="col-md-12 text-center btnOtr d-flex p-0">
                                        <button type="button" className="btn btn-secondary btnClr col" onClick={() => cancel()} data-dismiss="modal">
                                            Cancel
                                        </button>
                                        <button type="button" className="btn btn-primary btnRgion col" onClick={() => handleSubmit()}>
                                            Update {isSubmitting && <span className="spinner-border spinner-border-sm pl-2" role="status"></span>}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Draggable>
                </div>
            )}
        </React.Fragment>
    );
};
